const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgResize(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 500 500",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "rgba(186, 186, 186, 0.87)"
    },
    cx: 250,
    cy: 250,
    rx: 249.291,
    ry: 249.291
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M 366.391 120.513 C 373.606 120.513 379.485 126.363 379.485 133.609 L 379.485 250.001 C 379.485 257.216 373.606 263.095 366.391 263.095 C 359.145 263.095 353.298 257.216 353.298 250.001 L 353.298 165.208 L 165.209 353.297 L 250.001 353.297 C 257.218 353.297 263.093 359.147 263.093 366.391 C 263.093 373.608 257.218 379.487 250.001 379.487 L 133.609 379.487 C 130.118 379.487 126.799 378.088 124.327 375.642 C 121.882 373.171 120.515 369.855 120.515 366.391 L 120.515 250.001 C 120.515 242.755 126.363 236.907 133.609 236.907 C 140.824 236.907 146.705 242.755 146.705 250.001 L 146.705 334.762 L 334.762 146.703 L 250.001 146.703 C 242.755 146.703 236.907 140.825 236.907 133.609 C 236.907 126.363 242.755 120.513 250.001 120.513 L 366.391 120.513 Z",
    style: {
      transformBox: "fill-box",
      transformOrigin: "50% 50%",
      fill: "rgba(0, 0, 0, 0.694)"
    },
    transform: "matrix(0, 1, -1, 0, -0.00002, 0.000008)"
  }));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResize);
export default __webpack_public_path__ + "static/media/resize.c67888162b35abae38d4f0bd29e21565.svg";
export { ForwardRef as ReactComponent };